import Phaser from 'phaser';
import { PlayerController } from '../Entities/PlayerController';
import { AudioManager } from './AudioManager';
import { DiscordRichPresenceManager } from './DiscordRichPresenceManager';

export interface PortalConfig {
  id: string;
  targetId: string;
  x: number;
  y: number;
  type: 'portal_blue' | 'portal_purple';
}

export class PortalSystem {
  private scene: Phaser.Scene;
  private portals: Map<string, Phaser.Physics.Arcade.Sprite> = new Map();
  private portalConfigs: Map<string, PortalConfig> = new Map();
  private isTeleporting = false;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  public createPortals(configs: PortalConfig[], group: Phaser.Physics.Arcade.StaticGroup): void {
    configs.forEach((cfg) => {
      const portal = group.create(cfg.x, cfg.y, cfg.type) as Phaser.Physics.Arcade.Sprite;
      portal.setDepth(20);
      portal.setData('portalId', cfg.id);
      this.portals.set(cfg.id, portal);
      this.portalConfigs.set(cfg.id, cfg);

      // Pulse visual effect
      this.scene.tweens.add({
        targets: portal,
        alpha: 0.7,
        duration: 800,
        yoyo: true,
        repeat: -1,
      });
    });
  }

  public handlePlayerPortalOverlap(player: PlayerController, portalObj: Phaser.GameObjects.GameObject): void {
    if (this.isTeleporting) return;

    const portalId = portalObj.getData('portalId') as string;
    const cfg = this.portalConfigs.get(portalId);
    if (!cfg) return;

    const targetCfg = this.portalConfigs.get(cfg.targetId);
    if (!targetCfg) return;

    this.isTeleporting = true;
    AudioManager.playSFX('portal');

    if (cfg.type === 'portal_purple') {
      DiscordRichPresenceManager.updatePresence('Inside Secret Area', 'Found Secret Bonus Room!');
    } else {
      DiscordRichPresenceManager.updatePresence('Solving Portal Puzzle', 'Teleported through Portal');
    }

    // Teleport Flash Effect
    this.scene.cameras.main.flash(300, 147, 51, 234);

    player.setPosition(targetCfg.x, targetCfg.y);
    if (player.body) {
      const body = player.body as Phaser.Physics.Arcade.Body;
      body.setVelocity(0, 0);
    }

    this.scene.time.delayedCall(800, () => {
      this.isTeleporting = false;
    });
  }
}
